<template>
  <div class="searchResult">
    <!--    表格-->
    <el-card class="result">
      <div slot="header" class="title">
        检测结果
      </div>
      <div class="tip">
        <div class="tip-l" style="display: flex;font-size: 12px;margin: 20px 0;">
          <div>本次检测: <span style="font-weight: 700;font-size: 16px;"> {{allNums}} </span> 个，</div>
          <div style="cursor: pointer">成功：<span
            style="font-weight: 700;font-size: 16px;color: #07c160;">{{sucessNum}}</span>，
          </div>
          <div style="cursor: pointer">失败：<span
            style="font-weight: 700;font-size: 16px;color: orange;">{{failNum}}</span></div>
        </div>

        <div class="tip-r">
          <el-button type="medium" :disabled="isStarding" class="failReset" @click="failReset">失败重查</el-button>
          <el-button type="medium" :disabled="isStarding" class="port" @click="exportTable">导出结果</el-button>
        </div>
      </div>
      <el-table :data="tableData">
        <el-table-column prop="date" label="检测时间"></el-table-column>
        <el-table-column prop="url" label="域名" show-overflow-tooltip></el-table-column>
        <el-table-column v-for="item in tableHeader" :key="item.name" prop="url1" :label="item.name">
          <template slot-scope="{row}">
            <div v-if="row[item.interface_name] == 'load'">
              <i class="el-icon-loading"></i>
            </div>
            <div v-else-if="row[item.interface_name].code==500" style="color: red">检测失败</div>
            <div v-else-if="row[item.interface_name].code==200" style="color: green">{{row[item.interface_name].msg}}</div>
            <div v-else style="color: red">{{row[item.interface_name].msg}}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { export2Excel } from '@/utils/excel'
import { publicEncryptedData } from '@/utils/encrypted'

export default {
  data () {
    return {
      allNums:0,
      sucessNum:0,
      failNum:0,
      urlList:[],
      type:[],
      token:'',
      ctoken:'',
      tableHeader:[],
      tableData:[],
      isStarding:true,
      apiList:[]
    }
  },
  mounted() {
    this.$emit('iscreat')
  },
  methods:{
    start(form,apiList){
      // @ params
      // url:链接数组
      // type:检测方式id数组,
      // usertoken:用户密钥,
      // ctoken:验证码验签结果
      this.apiList = apiList
      form.type.forEach(item=>{
        let index = apiList.findIndex(name=> item == name.interface_name)
        this.tableHeader.push(apiList[index])
      })
      this.urlList = form.url
      this.type = form.type
      this.token = form.usertoken
      form.ctoken.api = form.type
      this.ctoken = form.ctoken
      this.allNums = form.url.length
      this.main()
    },
    main() {
      this.urlList.forEach((item,index)=>{
        let nowtime = new Date()
        let rowObj={
          date: nowtime.toLocaleString(),
          url:item,
        }
        this.tableHeader.forEach(item1=>{
          rowObj[item1.interface_name] = 'load'
        })
        this.tableData.push(rowObj)
        //延时一秒发送一个
        setTimeout(()=>{
          this.ctoken.time = Date.now()
          this.$http.post('/batch',{
            url: item,
            project: this.type,
            token: this.token ? this.token : undefined,
            ctoken: !this.token ? publicEncryptedData(JSON.stringify(this.ctoken),'encrypt') : undefined
          },{timeout:40000}).then(res=>{
            this.sucessNum += 1
            let index = this.tableData.findIndex(r=>r.url == item)
            for (var k in res.data) {
              this.tableData[index][k] = res.data[k]
            }
            if(this.failNum + this.sucessNum == this.allNums){
              this.$emit('jiancewanbi','')
              this.isStarding = false
            }
          }).catch(e=>{
            let index = this.tableData.findIndex(r=>r.url == item)
            this.type.forEach(item=>{
              this.tableData[index][item] = {code:500,msg:'检测失败'}
              this.tableData[index].code = 500
            })
            this.failNum += 1
            if(this.failNum + this.sucessNum == this.allNums){
              this.$emit('jiancewanbi','')
              this.isStarding = false
            }
          })
        },index*1000)
      })
    },
    //失败重查
    failReset(){
      if(this.tableData.length == 0) return this.$message.error('没有失败链接')
      this.failNum = 0
      let arr = new Set()
      let errorList = []
      this.tableData.forEach((item,index)=>{
        if(item.code == 500){
          errorList.push(item.url)
        }
        this.type.forEach(item2=>{
          if(item[[item2]].code == 500){
            item[item2] = 'load'
            arr.add(item.url)
          }
        })
      })
      Array.from(arr).forEach((url,index)=>{
        setTimeout(()=>{
          this.ctoken.time = Date.now()
          this.$http.post('/batch',{
            url:url,
            project:this.type,
            token: this.token ? this.token : undefined,
            ctoken: !this.token ? publicEncryptedData(JSON.stringify(this.ctoken),'encrypt') : undefined
          },{timeout:40000}).then(res=>{
            let index = this.tableData.findIndex(r=>r.url == url)
            for (var k in res.data) {
              this.tableData[index][k] = res.data[k]
            }
            if(errorList.findIndex(item=>item == url) >= 0){
              this.sucessNum += 1
            }
            if(this.failNum + this.sucessNum == this.allNums){
              this.$emit('jiancewanbi','')
              this.isStarding = false
            }
          }).catch(e=>{
            let index = this.tableData.findIndex(r=>r.url == url)
            this.type.forEach(item=>{
              this.tableData[index][item] = {code:500,msg:'检测失败'}
            })
            if(errorList.findIndex(item=>item == url) < 0){
              this.sucessNum -= 1
              this.failNum += 1
            }
            if(this.failNum + this.sucessNum == this.allNums){
              this.$emit('jiancewanbi','')
              this.isStarding = false
            }
          })
        },index*1000)
      })
    },
    exportTable(){
      if(this.tableData.length == 0){
        return this.$message.error('暂无数据可导')
      }
      var excel = []
      var header = [
        {
          title: '检测时间',
          key: 'date'
        },
        {
          title: '域名',
          key: 'url'
        },
      ]
      this.type.forEach(item=>{
        header.push({
          title: this.apiList[this.apiList.findIndex(i =>i.interface_name == item)].name,
          key:item
        })
      })
      this.tableData.forEach(item=>{
        var obj = {}
        for(var k in item){
          if(k == 'date' || k=='url'){
            obj[k] = item[k]
          }else {
            obj[k] = item[k].msg
          }
        }
        excel.push(obj)
      })
      export2Excel(header, excel)
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-table .cell {
  height: 20px !important;
}

.result {
  margin: 0 20px 20px 20px;
  //max-width: 1170px;

  .title {
    border-left: 3px solid #108cee;
    padding: 0 10px;
    line-height: 1;
    color: #515a6e;
    border-bottom: none;
    font-size: 16px;
    font-weight: 500;
  }

  /deep/ .el-card__header {
    height: 45px;
  }

  .selectC {
    width: 200px;
  }

  .tip {
    //margin-bottom: 15px;
    display: flex;
    justify-content: space-between;

    .tip-r {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 15px;

      .failReset {
        border-radius: unset !important;
        margin-left: 14px;
      }

      .failReset:hover {
        color: #fff !important;
        background-color: #2b85e4 !important;
      }

      .port {
        border-radius: unset !important;
        margin-left: 14px;
      }

      .port:hover {
        background-color: #eee;
        border-color: #ccc;
        color: #515a6e;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .result {
    margin: 0;
    .tip {
      display: unset !important;
      justify-content: unset !important;

      .tip-l {
        margin: 20px 15px !important;
      }

      .tip-r {
        justify-content: unset;
        overflow-x: auto;
      }
    }
  }
}
</style>
